import React, { useEffect, useRef } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
// core components
import AdminNavbar from '../components/Navbars/AdminNavbar'
import AdminFooter from '../components/Footers/AdminFooter'
import AdminSidebar from '../components/Sidebar/AdminSidebar'

import routes from '../routes'
import { Box } from '@mui/material'

function SuperAdmin(props) {
  var divRef = useRef(null)
  const user = localStorage.getItem('user-borku')
    ? JSON.parse(localStorage.getItem('user-borku'))
    : null
  const userType = user?.userType
  const permissions = user?.permissions || []

  const isRouteAllowed = route => {
    if (userType === 'ADMIN') return true
    if (userType === 'STAFF') {
      return permissions.includes('Admin') || permissions.includes(route.name)
    }
    return false
  }

  const allowedRoutes = routes.filter(
    route => route.layout === '/super_admin' && isRouteAllowed(route)
  )
  const fallbackRoute =
    allowedRoutes.length > 0
      ? allowedRoutes[0].layout + allowedRoutes[0].path
      : '/super_admin/dashboard'

  useEffect(() => {
    document.documentElement.scrollTop = 0
    document.scrollingElement.scrollTop = 0
    divRef.current.scrollTop = 0
  }, [])

  const getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === '/super_admin') {
        return (
          <Route
            path={prop.layout + prop.path}
            render={routeProps =>
              isRouteAllowed(prop) ? (
                <prop.component {...routeProps} />
              ) : (
                <Redirect to={fallbackRoute} />
              )
            }
            key={key}
          />
        )
      } else {
        return null
      }
    })
  }
  const getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props.location.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].label || routes[i].name
      }
    }
    return 'Brand'
  }
  return (
    <Box sx={{ backgroundColor: 'background.default', minHeight: '100vh' }}>
      <AdminSidebar />
      <Box
        sx={{
          marginLeft: { xs: 0, sm: '260px' },
          paddingTop: { xs: 8, sm: 0 },
          minHeight: '100vh',
          minWidth: 0,
          maxWidth: '100%',
          overflowX: 'hidden',
          // Column so the footer sits at the bottom of short pages instead of
          // floating halfway up the screen.
          display: 'flex',
          flexDirection: 'column'
        }}
        ref={divRef}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
        />
        <Box sx={{ px: { xs: 2, sm: 3, md: 4 }, pb: 3, flexGrow: 1 }}>
          <Switch>
            {getRoutes(routes)}
            <Redirect from="/super_admin" to={fallbackRoute} />
          </Switch>
        </Box>
        <AdminFooter />
      </Box>
    </Box>
  )
}

export default SuperAdmin
